import React from "react";
import EmailSend from '../../components/Contact/EmailSend';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
 
function Contact(props) {
  return (
      <div className="App">
        <Header/>
        <EmailSend/>
        <Footer/>
      </div>
  );
}
export default Contact;